import isEmpty from 'lodash/isEmpty';

export const formatCodeGiftCard = (v: string, onlyLast4?: boolean) => {
  if (isEmpty(v)) return '';
  if (onlyLast4) return `****-****-${v.slice(-4)}`;
  return v.replace(/(\d{4})(?=\d)/g, '$1-');
};

export const getGiftCardCode = (
  code: string,
  posGiftCardCode?: string,
  onlyLast4?: boolean,
) => {
  if (posGiftCardCode) return formatCodeGiftCard(posGiftCardCode, onlyLast4);
  return formatCodeGiftCard(code, onlyLast4);
};
